import { gql } from '@apollo/client';

export const SITE_ENTITY_SEARCH_BY_TEXT = gql`
    query siteEntitySearchByText($processFilter: ProcessFilter) {
        facility {
            id
            processes(filter: $processFilter) {
                id
                name
                description
                type
            }
        }
    }
`;
